<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import CreditsBanner from '@/components/Messages/CreditsBanner.vue'
import { formatDate } from '@/helpers/formating'
import { useGetUserCreditTransactionsList } from '@gto/api/vue-query'
import { useKeyTranslation } from '@/composables/useKeyTranslation'

const { translateKey } = useKeyTranslation()

const { data, isLoading } = useGetUserCreditTransactionsList({ limit: 999 })

const store = useStore()

const transactions = computed(() => data.value?.items)
</script>

<template>
  <div>
    <CreditsBanner style="margin-bottom: var(--app-gap-6)" />
    <div
      class="bottom_container d-flex"
      style="gap: var(--app-gap-6)"
    >
      <div
        class="balance_box"
        style="flex: 1 0 0px"
      >
        <div
          class="text-h7"
          style="color: var(--clr-grey-2)"
        >
          {{ $t('user_settings.credits_current_balance') }}
        </div>
        <div class="text-h3 pt-4 pb-4">
          {{
            $t('user_settings.credits_current_balance_value', {
              credits_balance: store.getters.user_info.credit_balance,
            })
          }}
        </div>
      </div>

      <div
        v-if="transactions && transactions.length"
        class="transaction_box"
        style="flex: 2 0 0px"
        :class="{ gw_loading: true }"
      >
        <div
          class="text-h7"
          style="color: var(--clr-grey-2); margin: 1rem"
        >
          {{ $t('user_settings.credits_usage_summary') }}
        </div>
        <div class="transaction_box_content d-flex flex-column large-scroll-track">
          <div
            v-for="(transaction, index) in transactions"
            :key="index"
            class="transaction_box_item d-flex flex-row"
            :class="isLoading ?? 'gw_loading_text'"
          >
            <div class="d-flex flex-column">
              <span>{{ translateKey(transaction.name, 'user_settings.transaction_types') }}</span>
              <span style="color: var(--clr-grey-2)">{{ transaction.description }}</span>
            </div>
            <div class="d-flex flex-column ml-auto">
              <span>
                {{
                  $t('user_settings.credits_current_balance_value', {
                    credits_balance: Math.floor(Number(transaction.amount)),
                  })
                }}
              </span>
              <span style="color: var(--clr-grey-2)">{{
                formatDate(transaction.date_created)
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bottom_container {
  min-height: 30rem;
  gap: 6rem;
  --clr-box: #405642;
}

@media (max-width: 1023px) {
  .bottom_container {
    flex-direction: column;
  }
}

.balance_box {
  --clr-type: var(--clr-box);
  --clr-back: linear-gradient(225deg, var(--clr-type), transparent);
  display: flex;
  flex-direction: column;

  padding: 1rem;
  border-radius: 1.875rem;
  background: var(--clr-back);
  border: 0.15rem solid var(--clr-box);

  min-height: 14.2rem;
  max-height: 14.2rem;
}

.transaction_box {
  --clr-transaction-border: #1f1f1f;
  --clr-transaction-background: #191919;

  display: flex;
  flex-direction: column;

  border-radius: 1.875rem;
  border: 0.15rem solid var(--clr-transaction-border);

  &_content {
    gap: 0.8rem;
    max-height: 30rem;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 0 0 1rem 0;
  }

  &_item {
    --clr-type: var(--clr-box);
    --clr-back: linear-gradient(225deg, var(--clr-type), transparent);
    display: flex;
    flex-direction: column;

    margin: 0 1rem 0 1rem;
    gap: 1rem;
    background: var(--clr-transaction-background);
    padding: 1rem;
    border-radius: 0.5rem;
    border: 0.15rem solid var(--clr-transaction-border);
  }
}
</style>
